import { $authHost, $host } from '.';

// Создать нового сотрудника
export const createEmployee = async (employeeData) => {
    try {
        // **Запрос:**
        // ```json
        // {
        //   "username": "doctor_ivanov",
        //   "password": "securepass123",
        //   "email": "ivanov@hospital.com",
        //   "first_name": "Иван",
        //   "last_name": "Иванов",
        //   "patronymic": "Петрович",
        //   "phone": "+79991234567",
        //   "sex": "M",
        //   "security_question": "Как звали вашу первую собаку?",
        //   "security_answer": "Шарик",
        //   "post_title": "Врач-терапевт",
        //   "medical_institution_title": "Городская больница №1",
        //   "medical_institution_address": "ул. Ленина, д. 15"
        // }
        // ```
        const { data } = await $host.post('/employees/', employeeData);
        // **Ответ (201 Created):**
        // ```json
        // {
        //   "id": 1,
        //   "user_id": 1,
        //   "post": 1,
        //   "medical_institution_title": "Городская больница №1",
        //   "medical_institution_address": "ул. Ленина, д. 15"
        // }
        // ```
        return data;
    } catch (e) {
        console.error('Creating employee failed:', e);
    }
};

// Получить список сотрудников
export const getEmployees = async () => {
    const { data } = await $authHost.get('/employees/');
    // **Ответ (200 OK):**
    // ```json
    // [
    //   {
    //     "id": 1,
    //     "user_id": 1,
    //     "post": 1,
    //     "medical_institution_title": "Городская больница №1",
    //     "medical_institution_address": "ул. Ленина, д. 15"
    //   }
    // ]
    // ```
    return data;
};

// Получить сотрудника по ID
export const getOneEmployee = async (employeeId) => {
    const { data } = await $authHost.get(`/employees/${employeeId}/`);
    return data;
};

// Обновить сотрудника
export const updateEmployee = async (employeeId, employeeData) => {
    const { data } = await $authHost.put(`/employees/${employeeId}/`, employeeData);
    return data;
};

// Удалить сотрудника
export const deleteEmployee = async (employeeId) => {
    const { data } = await $authHost.delete(`/employees/${employeeId}/`);
    return data;
};

// Получить информацию о пользователе сотрудника
export const getEmployeeUser = async (employeeId) => {
    const { data } = await $authHost.get(`/employees/${employeeId}/user/`);
    return data;
};

// Получить информацию о должности сотрудника
export const getEmployeePost = async (employeeId) => {
    const { data } = await $authHost.get(`/employees/${employeeId}/post/`);
    return data;
};

// ### PUT/PATCH /api/employees/{id}/post/
// Обновить должность сотрудника
export const updateEmployeePost = async (employeeId, employeePostData) => {
    const { data } = await $authHost.put(`/employees/${employeeId}/post/`, employeePostData);
    return data;
};

// export const connectUserToEmployee = async (employeeId) => {
//     try {
//         const response = await $authHost.get(`/employee/${employeeId}/user`);

//         if (
//             response.data.code === 'unauthorized' ||
//             response.data.code === 'not_found' ||
//             response.data.code === 'forbidden'
//         ) {
//             throw new Error(response);
//         }

//         const user = response.data;
//         return user;
//     } catch (e) {
//         console.error('Connecting user to employee failed:', e);
//     }
// };

// export const updateEmployeePostTitle = async (employeeId) => {
//     try {
//         const response = await $authHost.patch(`/employee/${employeeId}/post`);

//         if (
//             response.data.code === 'unauthorized' ||
//             response.data.code === 'not_found' ||
//             response.data.code === 'forbidden'
//         ) {
//             throw new Error(response);
//         }

//         const employee = response.data;
//         return employee;
//     } catch (e) {
//         console.error('Updating employee pos title failed:', e);
//     }
// };

